/**
 * Onboarding utilities and constants
 *
 * Location: frontend/src/pages/onboarding/utils/onboarding.js
 */

/**
 * Routes that are allowed during onboarding without redirecting back
 * Users can visit these pages and return to /onboarding to continue
 */
export const ONBOARDING_ALLOWED_ROUTES = [
  "/envelopes/new",
  "/templates",
  "/onboarding",
];

/**
 * Check if a pathname matches any allowed route
 */
export const isAllowedRoute = (pathname) =>
  ONBOARDING_ALLOWED_ROUTES.some(
    (route) =>
      // Exact match or starts with (for nested routes like /templates/123)
      pathname === route || pathname.startsWith(`${route}/`),
  );

/**
 * Helper to get and clear the post-onboarding redirect URL
 */
export const getOnboardingRedirect = () => {
  const redirect = sessionStorage.getItem("onboarding_redirect");
  sessionStorage.removeItem("onboarding_redirect");
  return redirect || "/dashboard";
};

/**
 * Session storage key for current onboarding step
 */
export const ONBOARDING_STEP_KEY = "onboarding_current_step";

/**
 * Get stored onboarding step
 */
export const getStoredStep = () => {
  const stored = sessionStorage.getItem(ONBOARDING_STEP_KEY);
  return stored ? parseInt(stored, 10) : 0;
};

/**
 * Store current onboarding step
 */
export const setStoredStep = (step) => {
  sessionStorage.setItem(ONBOARDING_STEP_KEY, String(step));
};

/**
 * Clear stored onboarding step (on completion)
 */
export const clearStoredStep = () => {
  sessionStorage.removeItem(ONBOARDING_STEP_KEY);
};
